export const SAVE_BODY_FAT = 'measurements/SAVE_BODY_FAT';
export const SAVE_BODY_FAT_SUCCESS = 'measurements/SAVE_BODY_FAT_SUCCESS';
export const SAVE_BODY_FAT_ERROR = 'measurements/SAVE_BODY_FAT_ERROR';
export const CLEAR_BODY_FAT_ERRORS = 'measurements/CLEAR_BODY_FAT_ERRORS';

export const GET_USER_BF_MEASUREMENTS = 'measurements/GET_USER_BF_MEASUREMENTS';
export const GET_USER_BF_MEASUREMENTS_SUCCESS = 'measurements/GET_USER_BF_MEASUREMENTS_SUCCESS';
export const GET_USER_BF_MEASUREMENTS_ERROR = 'measurements/GET_USER_BF_MEASUREMENTS_ERROR';